export enum MarkingResult {
    QUALIFIED = "QUALIFIED", DISQUALIFIED = "DISQUALIFIED",
  }